import { useEffect } from 'react';
import { usePaginationParams } from '@common-fe/common-fe';

import { ALL_OPTION } from '@/common/constants';
import { OptionKey } from '@/common/types';
import { LockboxStatus } from '@/modules/employer/components/Lockbox/lockbox.types';
import { useFilters } from '@/utils';

const useListPagination = (defaultPerPage?: number) => {
  const {
    page, setPage, setPerPage, perPage, searchString, setSearchString, currentSearch,
  } = usePaginationParams(defaultPerPage);

  const { filtersValues, setFilterValue } = useFilters<{
    statuses: OptionKey[],
    types: OptionKey[],
    paymentTypes: OptionKey[],
  }>({
    statuses: [LockboxStatus.NEW, LockboxStatus.PENDING],
    types: [ALL_OPTION.value],
    paymentTypes: [ALL_OPTION.value],
  }, { autoClear: true });

  useEffect(() => {
    setPage(1);
  }, [setPage, currentSearch, filtersValues.statuses, filtersValues.types]);

  return {
    page,
    setPage,
    setPerPage,
    perPage,
    searchString,
    statuses: filtersValues.statuses,
    types: filtersValues.types,
    setSearchString,
    currentSearch,
    setStatuses: setFilterValue.statuses,
    setTypes: setFilterValue.types,
    paymentTypes: filtersValues.paymentTypes,
    setPaymentTypes: setFilterValue.paymentTypes,
  };
};

export default useListPagination;
